export default "__VITE_ASSET__CwD1mNKk__"